import React, { useReducer } from 'react';
import { Button } from '@mui/material';
import styled from 'styled-components';

import ApplicationBar from 'components/ApplicationBar';
import Paper from 'components/Paper';
import Progress from 'components/Progress';
import { reducer } from 'state';
import Template from 'types/Template';
import Preview from 'pages/newTemplate/preview';
import TemplateForm from 'pages/newTemplate/TemplateForm';

const StyledButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  margin: 1rem;

  & > *:not(:last-child) {
    margin-right: 1rem;
  }
`;

const StyledPaper = styled(Paper)`
  & > *:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

const StyledEditTemplate = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;

  margin: 1rem;

  & > :first-child {
    flex-grow: 1;
    margin-right: 1rem;
  }

  & > :last-child {
    width: 40%;
  }
`;

interface EditTemplateProps {
  saving: boolean;
  template: Template;
  onCancel: () => void;
  onSave: (template: Template) => void;
}

const EditTemplate: React.FC<EditTemplateProps> = ({ saving, template: initialTemplate, onCancel, onSave }) => {
  const [template, dispatch] = useReducer(reducer, initialTemplate);

  return (
    <>
      {saving && <Progress />}

      <StyledButtons>
        <Button variant="contained" disabled={saving} onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" disabled={saving} onClick={() => onSave(template as Template)}>
          Save
        </Button>
        <ApplicationBar showCollectionPicker={false} />
      </StyledButtons>

      <StyledEditTemplate>
        <TemplateForm template={template} dispatch={dispatch} />
        <StyledPaper>{template !== null && <Preview template={template} dispatch={dispatch} />}</StyledPaper>
      </StyledEditTemplate>
    </>
  );
};

export default EditTemplate;
